import React, {useState, useEffect} from "react"
import _ from "lodash"

import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import { NotesEdit_s } from "components/notes/notes-styles"

type NoteDetail = {
  notes: string
}

const NotesEdit = (props: {rowData: {}, field: string, persist: Function}) => {
  const [data, set_data] = useState<NoteDetail>(_.get(props.rowData, props.field))

  useEffect(() => {
    set_data(_.get(props.rowData, props.field))
  }, [props.rowData])

  const clear = () => {
    props.persist({notes: ""}, props.field, props.rowData)
    set_data({notes: ""})
  }

  return (
    <div>
      <NoneStateTrashIcon persist={clear}/>
      <NotesEdit_s>
        <textarea
          className="automated"
          value={_.get(data, "notes") || ""}
          onChange={e => set_data({notes: e.target.value})}
          onBlur={() => props.persist(data, props.field, props.rowData)}
        />
      </NotesEdit_s>
    </div>
  )
}

export default NotesEdit
